import axios from "axios"
import { IRequestModel, IResponseModel } from "./_models"
import { CONST_API_FOURNISSEUR_GET_LISTING_ENDPOINT } from "../../../../endpoints"

export function getFournisseurListingRequest(payload: IRequestModel) {
     return axios.post<IResponseModel>(CONST_API_FOURNISSEUR_GET_LISTING_ENDPOINT, payload)
}
